import { useMutation } from "react-query";

import { disableUserInsuranceAsync } from "api/insurance";
import { useGlobalToast } from "components/GlobalToastProvider";

const useDisableClientInsurance = (options = {}) => {
  const { onError = () => {}, onSuccess = () => {}, ...otherOptions } = options;
  const { showToast } = useGlobalToast();

  const { mutate, mutateAsync, isIdle, isLoading, ...rest } = useMutation(
    (payload) => disableUserInsuranceAsync(payload),
    {
      onSuccess: () => {
        showToast({
          message: "Insurance inactivated successfully!",
        });
        onSuccess();
      },
      onError: () => {
        showToast({
          message: "Whoops! Something went wrong while inactivating insurance",
          errorState: true,
        });
        onError();
      },
      ...otherOptions,
    }
  );

  return {
    disableInsuranceMutation: mutate,
    mutateAsync,
    isMutationDisableInsuranceIdle: isIdle,
    isMutationDisableInsuranceLoading: isLoading,
    ...rest,
  };
};

export default useDisableClientInsurance;
